import { push } from 'connected-react-router';
import React from 'react';
import { useDispatch } from 'react-redux';

// TCC Components
import { App } from '../../App'
import { IconLock } from '../../capturecollab/Icons';
import { StyledLockIcon } from '../../capturecollab/modules/Permission/NoPermissions';
import { SmartContainer, Surface } from '../../styles/Containers'
import { StyledButton } from '../../styles/matieralui/Button';
import { StyledH1, StyledP } from '../../styles/StyledHTML'

export const NoAccessPermission = () => {
    const dispatch = useDispatch();
    const goTo = (path) => dispatch(push('/'))
    return (
        <SmartContainer flex align="center" justify="center" width="100%" minHeight="70vh">
            <SmartContainer maxWidth="450px" textAlign="center">
                <SmartContainer flex align="center" justify="center" width="100%"><StyledLockIcon><IconLock color="white" /></StyledLockIcon></SmartContainer>
                <br />
                <StyledH1>Pump the breaks.</StyledH1>
                <br />
                <StyledP>You don't have access to this content. Ask your admin to change your permissions.</StyledP>
                <br />
                <StyledP><StyledButton variant='contained' color='blue' onClick={goTo}>Back Home</StyledButton></StyledP>
            </SmartContainer>
        </SmartContainer>
    );
}